import { createContext, useContext } from "react";

type WACalendarOverviewContextT = {
  calendarIds: string[];
  setCalendarIds(calendarIds: string[]): void;
};

export const WACalendarOverviewContext =
  createContext<WACalendarOverviewContextT>({
    calendarIds: [],
    setCalendarIds: () => {},
  });

export function useWACalendarOverviewContext() {
  return useContext(WACalendarOverviewContext);
}
